import { render } from "./tickets.vue?vue&type=template&id=d6b78db2&scoped=true"
import script from "./tickets.vue?vue&type=script&lang=js"
export * from "./tickets.vue?vue&type=script&lang=js"

import "./tickets.vue?vue&type=style&index=0&id=d6b78db2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6b78db2"]])

export default __exports__